import React from 'react'
import { useToggle } from 'react-use'
import { useError } from '@ztechapps/common.hook'
import { BusyButton } from '@ztechapps/webui.button'
import { buildDocumentLinkPdfUrl, getWindow } from '@ztechapps/common.utils'
import { useCreateOrderDocumentLink } from '@ztechapps/order.common'
import { useContext } from '../../components/Order/Context'

export const PrintInvoice = () => {
  const { document } = useContext()
  const { mint } = useCreateOrderDocumentLink()
  const { onError } = useError()
  const [isBusy, setIsBusy] = useToggle(false)

  const onClick = async () => {
    setIsBusy(true)
    try {
      const { token } = await mint(document?._id)
      getWindow().open(buildDocumentLinkPdfUrl({ token }), '_blank', 'noopener,noreferrer')
    } catch (e) {
      onError(e)
    } finally {
      setIsBusy(false)
    }
  }

  return <BusyButton icon="print" text="Print" onClick={onClick} isBusy={isBusy} />
}
